<script lang="ts">
  import type { IconsBaseProps } from './icons.types.ts';

  let { class: className, size = 6, title, ...rest }: IconsBaseProps = $props();
</script>

<svg {...rest} width={size * 4} height={size * 4} class={className} viewBox="0 0 16 17">
  {#if title}<title>{title}</title>{/if}
  <path
    d="M8.00033 4.83333C10.527 4.83333 12.7803 6.25333 13.8803 8.5C12.7803 10.7467 10.5337 12.1667 8.00033 12.1667C5.46699 12.1667 3.22033 10.7467 2.12033 8.5C3.22033 6.25333 5.47366 4.83333 8.00033 4.83333ZM8.00033 3.5C4.66699 3.5 1.82033 5.57333 0.666992 8.5C1.82033 11.4267 4.66699 13.5 8.00033 13.5C11.3337 13.5 14.1803 11.4267 15.3337 8.5C14.1803 5.57333 11.3337 3.5 8.00033 3.5ZM8.00033 6.83333C8.92033 6.83333 9.66699 7.58 9.66699 8.5C9.66699 9.42 8.92033 10.1667 8.00033 10.1667C7.08033 10.1667 6.33366 9.42 6.33366 8.5C6.33366 7.58 7.08033 6.83333 8.00033 6.83333ZM8.00033 5.5C6.34699 5.5 5.00033 6.84667 5.00033 8.5C5.00033 10.1533 6.34699 11.5 8.00033 11.5C9.65366 11.5 11.0003 10.1533 11.0003 8.5C11.0003 6.84667 9.65366 5.5 8.00033 5.5Z"
    fill="#363636"
  />
</svg>
